module.exports = __webpack_public_path__ + "img/logo300.89429efd.png";